/* Controller Imports */
import SecurityGroupsListController from './list/list.controller';
import SecurityGroupCreateController from './create-group/create.controller';
import SecurityGroupViewDeleteModalController from './view/delete-modal/delete.modal.controller';
import SecurityGroupsViewAssetsController from './view/assets/assets.controller';

import SecurityGroupsViewController from './view/view.controller';
import SecurityGroupsViewUsersController from './view/users/users.controller';
import SecurityGroupViewUserSelectionModalController from './view/users/users-modal/users.modal';

const securityGroupsModule = angular
  .module('app.securityGroupManagement', ['ui.bootstrap', 'ui.router', 'gettext'])
  .controller('SecurityGroupsListController', SecurityGroupsListController)
  .controller('SecurityGroupCreateController', SecurityGroupCreateController)
  .controller('SecurityGroupViewDeleteModalController', SecurityGroupViewDeleteModalController)
  .controller('SecurityGroupsViewAssetsController', SecurityGroupsViewAssetsController)

  .controller('SecurityGroupsViewController', SecurityGroupsViewController)
  .controller('SecurityGroupsViewUsersController', SecurityGroupsViewUsersController)
  .controller(
    'SecurityGroupViewUserSelectionModalController',
    SecurityGroupViewUserSelectionModalController,
  );
export default securityGroupsModule.name;
